import { UserRef } from 'dy-frontend-http-repository/lib/modules/User/refs';
import { UpdateUserEmailSettingsInput } from 'dy-frontend-http-repository/lib/modules/User/inputs';
import domain from './domain';
import { repository } from 'dy-frontend-http-repository/lib/modules';

// Update user email settings
export const updateUserEmailSettings = domain.createEffect<
    { userId: ID; input: UpdateUserEmailSettingsInput },
    UserRef
>({
    name: 'updateUserEmailSettings',
    handler: async ({ userId, input }) => {
        return await repository.user().updateEmailSettings(userId, input);
    },
});
